export const STORE_KEY = '$submissions'

export const LOAD_SUBMISSIONS = 'LOAD_SUBMISSIONS'
export const LOAD_SUBMISSION_RESOLUTIONS = 'LOAD_SUBMISSION_RESOLUTIONS'
export const LOAD_SUBMISSION_STATUSES = 'LOAD_SUBMISSION_STATUSES'
export const LOAD_SUBMISSION_PRIORITIES = 'LOAD_SUBMISSION_PRIORITIES'
export const RESET_STORE = 'RESET_STORE'
export const RESET_QUERY = 'RESET_QUERY'
export const RELOAD_SUBMISSIONS = 'RELOAD_SUBMISSIONS'
export const SET_ACTIVE_RESEARCHER_POPOVER = 'SET_ACTIVE_RESEARCHER_POPOVER'
export const SET_FILTER_OPTION = 'SET_FILTER_OPTION'
export const SET_SORT_OPTION = 'SET_SORT_OPTION'
export const SET_SORT_ORDER = 'SET_SORT_ORDER'
export const SET_SUBMISSIONS = 'SET_SUBMISSIONS'
export const UPDATE_SUBMISSIONS = 'UPDATE_SUBMISSIONS'
export const SET_SUBMISSION_RESOLUTIONS = 'SET_SUBMISSION_RESOLUTIONS'
export const SET_SUBMISSION_STATUSES = 'SET_SUBMISSION_STATUSES'
export const SET_SUBMISSION_PRIORITIES = 'SET_SUBMISSION_PRIORITIES'
export const SET_SUBMISSIONS_QUERY = 'SET_SUBMISSIONS_QUERY'
export const SET_SUBMISSIONS_QUERY_PAGE = 'SET_SUBMISSIONS_QUERY_PAGE'
export const GET_SUBMISSION_PRIORITIES = 'GET_SUBMISSION_PRIORITIES'
export const GET_SUBMISSION_RESOLUTIONS = 'GET_SUBMISSION_RESOLUTIONS'

export const GET_KANBAN_STATUS = 'GET_KANBAN_STATUS'
export const TOGGLE_KANBAN_STATUS = 'TOGGLE_KANBAN_STATUS'
export const SET_KANBAN_SUBMISSIONS = 'SET_KANBAN_SUBMISSIONS'
export const LOAD_KANBAN_SUBMISSIONS = 'SET_KANBAN_SUBMISSIONS'

export const GET_SUBMISSIONS = 'GET_SUBMISSIONS'
export const SET_PRIORITY_QUERY = 'SET_PRIORITY_QUERY'
export const SET_STATUS_QUERY = 'SET_STATUS_QUERY'
export const SET_SUBMISSIONS_QUERY_SUBMISSION_NAME = 'SET_SUBMISSIONS_QUERY_SUBMISSION_NAME'
export const SET_SUBMISSIONS_QUERY_PAYMENT = 'SET_SUBMISSIONS_QUERY_PAYMENT'
export const SET_SUBMISSIONS_QUERY_VALID = 'SET_SUBMISSIONS_QUERY_VALID'
